module.exports = __webpack_public_path__ + "media/components/listings/listing/summary/row3/photos/images/loading-1bb27a5b4c179eeecb64e8b06eb3c56c.gif";